import { useState } from 'react'
import { StyledButton } from '@/src/modules/pg-plus/PGPlusStyledComponents'
import { useGiftQuantityContext } from '@/src/common/contexts/GiftQuantityContext'
import CollectionOfRecipientForms from '@/src/modules/build-a-card/inputs/CollectionOfRecipientForms'
import TextDeliveryMessage from '@/src/modules/build-a-card/TextDeliveryMessage'
import { MEDIUM_TYPE_VIRTUAL } from '@/prisma/schemaConstants'
import QuantitySelectorButton from '@/src/common/components/elements/Buttons/QuantitySelectorButton'
import SelectDeliveryMethod from '@/src/modules/build-a-card/inputs/SelectDeliveryMethod'
import { slideDown } from '@/src/common/animations'
import PurchaseFlowMaxAlert from '@/src/common/components/elements/Alerts/PurchaseFlowMaxAlert'
import { useBasicGiftCardContext } from '@/src/common/contexts/BasicGiftCardContext'
import { HeaderParagraphText } from '@/src/modules/build-a-card/StyledComponents'
import { FieldWrapperWithGap } from '@/src/common/components/elements/Forms/StyledComponents'
import { SimpleFieldWrapper } from '@/src/modules/build-a-card/StepElement'
import KYCFlowMaxErrors from '@/src/common/components/elements/Alerts/KYCFlowMaxErrors'
import KYCMaxPurchaseButtons from '@/src/modules/kyc/buttons/KYCMaxPurchaseButtons'
import { useCartContext } from '@/src/common/contexts/CartContext'
import { useRouter } from 'next/router'

export const PGPlusStep2RightContent = () => {
    const {
        setIsLoading,
        setContinueIsLoading,
        isLoading,
        continueIsLoading,
        validateAndAddCart,
        setDisplayLiveErrors,
        giftState,
        dispatch,
        KYCMinMaxLimits,
    } = useGiftQuantityContext()
    const { partnerData } = useBasicGiftCardContext()
    const { cartTotalCards, setCartFlyoutOpen } = useCartContext()
    const { isEditing, sendingViaEmail, brandName } = giftState
    const router = useRouter()
    const {
        loadAmountMeetsKYCMin,
        numberOfCardsMeetsKYCMin,
        loadAmountExceedsKYCMax,
        numberOfCardsExceedsKYCMax,
    } = KYCMinMaxLimits
    const [showTextInfo, setShowTextInfo] = useState<boolean>(false)

    const showKYCMaxError: boolean =
        loadAmountExceedsKYCMax || numberOfCardsExceedsKYCMax
    const showKycLimitAlert =
        (loadAmountMeetsKYCMin || numberOfCardsMeetsKYCMin) && !showKYCMaxError

    return (
        <FieldWrapperWithGap
            data-testid={'pg-plus-form'}
            style={{
                animation: `${slideDown} 0.5s ease-in-out`,
            }}
        >
            <SelectDeliveryMethod
                label={'4. Choose a delivery method'}
                analyticsFlowType={`${brandName} eGift`}
            />
            {!isEditing && (
                <QuantitySelectorButton
                    giftState={giftState}
                    dispatch={dispatch}
                    ctaUrl="https://www.perfectgift.com/corporate/brands"
                    label={'5. Choose the quantity'}
                    partnerData={partnerData}
                />
            )}
            <SimpleFieldWrapper>
                <HeaderParagraphText>
                    Recipient information:
                </HeaderParagraphText>
                <CollectionOfRecipientForms />
            </SimpleFieldWrapper>
            {showKYCMaxError && <KYCFlowMaxErrors />}
            {showKycLimitAlert && <PurchaseFlowMaxAlert />}
            <SimpleFieldWrapper>
                {showKYCMaxError ? (
                    <KYCMaxPurchaseButtons
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        cartTotalCards={cartTotalCards}
                        setCartFlyoutOpen={setCartFlyoutOpen}
                        router={router}
                    />
                ) : (
                    <>
                        <StyledButton
                            id={'submit-button'}
                            label={
                                !isEditing
                                    ? 'Add to cart & checkout'
                                    : 'Save changes'
                            }
                            showArrow
                            onClick={() => {
                                setDisplayLiveErrors(true)
                                setIsLoading(true)
                                validateAndAddCart({
                                    productMediumType: MEDIUM_TYPE_VIRTUAL,
                                    keepShopping: false,
                                })
                            }}
                            textTransform={'uppercase'}
                            width={'wide'}
                            isLoading={isLoading}
                            disabled={isLoading || continueIsLoading}
                            type={'submit'}
                        />
                        <StyledButton
                            id={'submit-and-continue-button'}
                            variant={'primaryOutline'}
                            label={
                                !isEditing
                                    ? 'Add to cart & keep shopping'
                                    : 'Save & keep shopping'
                            }
                            showArrow={true}
                            onClick={() => {
                                setDisplayLiveErrors(true)
                                setContinueIsLoading(true)
                                validateAndAddCart({
                                    productMediumType: MEDIUM_TYPE_VIRTUAL,
                                    keepShopping: true,
                                })
                            }}
                            textTransform={'uppercase'}
                            width={'wide'}
                            isLoading={continueIsLoading}
                            disabled={isLoading || continueIsLoading}
                            type={'submit'}
                        />
                    </>
                )}
                {!sendingViaEmail && (
                    <TextDeliveryMessage
                        showTextInfo={showTextInfo}
                        setShowTextInfo={setShowTextInfo}
                    />
                )}
            </SimpleFieldWrapper>
        </FieldWrapperWithGap>
    )
}
